module.exports = __webpack_public_path__ + "static/media/AnandSoni@2x.6e150b08.png";